import { AxiosPromise }                           from 'axios';
import { client }                                 from '@/service/client';
import { EditUserRequest, PostUserRequest, User } from '@/views/users/users.types';

export function saveUser(user: PostUserRequest): AxiosPromise {
  return client.post('/users', user);
}

export function getUsers(): AxiosPromise {
  return client.get('/users');
}

export function removeUser({ uuid }: User): AxiosPromise {
  return client.delete(`/users/${uuid}`);
}

export function editUser(user: EditUserRequest): AxiosPromise {
  const { uuid, ...body } = user;
  return client.put(`/users/${uuid}`, body);
}

export function editPassword(uuid: string, password: string) {
  return client.put(`/users/${uuid}/password`, { password });
}
